import React, { useEffect, useState } from "react";
import { IPetsyRetrieveQuotePopups } from "./PetsyRetrieveQuotePopups.types";
import {
  Modal,
  Button,
} from "react-bootstrap";
import "./PetsyRetrieveQuotePopups.scss";
import _ from "lodash";
import {
  getFlowDataDirect,
  TextMask
} from "@adaptis/flow-components";

export default function PetsyStartAgainQuotePopup(props: IPetsyRetrieveQuotePopups) {
  const [renderKey, setRenderKey] = React.useState(0);
  const emailValidationPattern = `[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.+[A-Za-z]{2,63}$`;
  const [isInvalidEmail, setIsInvalidEmail] = React.useState<boolean>(true);
  const [isTouchedEmail, setIsTouchedEmail] = React.useState<boolean>(false);
  const [emailInitialValue, setEmailInitialValue] = useState("");
  const [enableButton, setEnableButton] = React.useState<boolean>(true);
  const [showStartContent, setShowStartContent] = React.useState<boolean>(true);
  function checkInputsIfValid() {
    let invalidEmail = true;
    if (emailInitialValue) {
      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(emailInitialValue)) {
        invalidEmail = true;
        setEnableButton(true);
        return;
      } else {
        invalidEmail = false;
        setEnableButton(false);
      }
    }
  }

  function modalClose() {
    props.onClose();
  }

  const optionRef = React.useRef<any>();
  function submit() {
    checkInputsIfValid();
    if (!enableButton) {
      setShowStartContent(false);
    } else {
      setRenderKey((renderKey) => renderKey + 1);
    }
  }

  function handleShowStep1() {
    return (
      <>
        <div className="ref-row">
          <div className="start-again-welcome-back-content">

            <div className="ref-image">
              <img src="/images/clap-icon.png" />
            </div>
            <div className="pt-4">
              <h1 className="purple-text bold font-brandon">Welcome Back!</h1>
            </div>
            <p className="purple-text">
              It’s nice to see you again - select one of the below options to continue!
            </p>
          </div>
        </div>

        <div className="ref-row mt-4">
          <Button
            key={renderKey}
            disabled={false}
            className={"flc_next-button btn purple font-brandon"}
            onClick={() => {
              setShowStartContent(false);
            }}
          >
            Continue My Quote
          </Button>
        </div>

        <div className="ref-row mt-3">
          <label className="or bold purple-text dark">
            OR
          </label>
        </div>

        <div className="ref-row mt-4 mb-4">
          <Button
            key={renderKey}
            disabled={false}
            className={"flc_next-button btn purple font-brandon"}
            onClick={submit}
          >
            Start a new quote
          </Button>
        </div>
      </>
    )
  }

  function handleShowStep2() {
    const paramTextMask = {
      id: "numPhone",
      prompt: "Enter your Mobile Number",
      minLength: 12,
      maxLength: 12,
      required: false,
      type: "text-mask",
      mask: "phone",
      dataField: "sendQuoteToPhone",
      invalidMessage: "",
      // onChange: handleOnChangePhone,
      // onBlur: handleOnBlurPhone,
    };

    return (
      <>
        <div className="ref-row">
          <div className="start-again-welcome-back-content">

            <div className="ref-image">
              <img src="/images/clap-icon.png" />
            </div>
            <div className="pt-4">
              <h1 className="purple-text bold font-brandon">Continue your quote</h1>
            </div>
            <p className="purple-text">
              Enter your mobile number or email to pick up where you left off.
            </p>
          </div>
        </div>

        <TextMask {...paramTextMask} value={``} />
        <div className="ref-row mt-3">
          <label className="or">
            OR
          </label>
        </div>
        <div className={"form-floating mt-4"}>
          <input
            name="name"
            placeholder="Email address"
            aria-describedby="textHelpBlock"
            id="textEmailAddress"
            value={emailInitialValue}
            readOnly={true}
            className={
              "form-control " +
              (isTouchedEmail
                ? isInvalidEmail
                  ? " is-invalid"
                  : "is-valid"
                : "")
            }
            type="email"
            pattern={emailValidationPattern}
            onChange={(e) => {

            }}
            onBlur={(e) => {
              e.preventDefault();

              if (e.target.value == "") setIsTouchedEmail(false);

              checkInputsIfValid();
            }}
          />
          <div className="invalid-feedback"></div>
          <label>Email address</label>
        </div>
        <div className="ref-row mt-4 mb-4">
          <Button
            key={renderKey}
            className={"flc_next-button btn purple font-brandon"}
            onClick={submit}
          >
            Continue
          </Button>
        </div>
      </>
    )
  }
  return (
    <>
      <Modal
        className="flc_petsy-retrieve-quote-popup start-again-quote-popup"
        show={props.show}
        onHide={modalClose}
        backdrop="static"
        keyboard={false}
        fullscreen="sm-down"
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="text-center" ref={optionRef}>
          {showStartContent ? handleShowStep1() : handleShowStep2()}
        </Modal.Body>
      </Modal>
    </>
  );
}
